// EVENTS
export enum EOutsetaEvents {
  ACCESS_TOKEN_SET = 'accessToken.set',
  AUTH_INITIALIZED = 'auth.initialized',
  AUTH_CLOSE = 'auth.close',
  REDIRECT = 'redirect',
  SIGNUP_REGISTRATION_DATA = 'signup.registrationData',
  SIGNUP_PRE_REGISTER = 'signup.preRegister',
  SIGNUP = 'signup',
  LOGOUT = 'logout',
  NOCODE_ACCESS_DENIED = 'nocode.accessDenied',
  NOCODE_EXPIRED = 'nocode.expired',
  NOCODE_INITIALIZED = 'nocode.initialized',
  ACCOUNT_UPDATE = 'account.update',
  PAYMENT_INFORMATION_UPDATE = 'paymentInformation.update',
  PROFILE_CLOSE = 'profile.close',
  PROFILE_INITIALIZED = 'profile.initialized',
  PROFILE_UPDATE = 'profile.update',
  SUBSCRIPTION_CANCEL = 'subscription.cancel',
  SUBSCRIPTION_REOPEN = 'subscription.reopen',
  SUBSCRIPTION_UPDATE = 'subscription.update',
}

// SUBSCRIPTION CHANGED
export interface IOutsetaSubscriptionChangedEvent {
  _objectType: string;
  BillingRenewalTerm: number;
  Account: unknown;
  Plan: IOutsetaPlanCommonEvent;
  Quantity: number;
  StartDate: string;
  EndDate: unknown;
  ExpirationDate: unknown;
  RenewalDate: string;
  NewRequiredQuantity: unknown;
  IsPlanUpgradeRequired: boolean;
  PlanUpgradeRequiredMessage: unknown;
  SubscriptionAddOns: unknown[];
  DiscountCouponSubscriptions: unknown[];
  DiscountCode: unknown;
  LatestInvoice: unknown;
  Rate: number;
  ActivityEventData: unknown;
  Uid: string;
  Created: string;
  Updated: string;
}

// SUBSCRIPTION CANCEL
export interface IOutsetaSubscriptionCancelEvent {
  Account: {
    Uid: string;
  };
  PriorAccountStage: number;
  CancelationReason: string;
  SubmittedDateTime: string;
}

// SIGNUP REGISTRATION DATA
export interface IOutsetaSignupRegistrationDataEvent {
  Account: Account;
  BillingRenewalTerm: number;
  Plan: Plan;
  Quantity: number;
  SubscriptionAddOns: unknown[];
}

// SIGNUP PRE REGISTER EVENT
export interface IOutsetaSignupPreRegisterEvent {
  BillingAddress: BillingAddress;
  PersonAccount: PersonAccount[];
  Nonce: string;
  RecaptchaToken: unknown;
  Subscriptions: Subscription[];
}

export interface Subscription {
  BillingRenewalTerm: number;
  Plan: Plan;
  Quantity: number;
  SubscriptionAddOns: SubscriptionAddOn[];
}

export interface PlanAddOn {
  _objectType: string;
  Plan: unknown;
  AddOn: AddOn;
  IsUserSelectable: boolean;
  ActivityEventData: unknown;
  Uid: string;
  Created: string;
  Updated: string;
}

export interface AddOn {
  _objectType: string;
  Name: string;
  BillingAddOnType: number;
  IsQuantityEditable: boolean;
  MinimumQuantity: number;
  MonthlyRate: number;
  AnnualRate: number;
  SetupFee: number;
  UnitOfMeasure: string;
  IsTaxable: boolean;
  IsBilledDuringTrial: boolean;
  ExpiresAfterMonths: number;
  ExpirationDate: unknown;
  StripeTaxCodeId: unknown;
  PlanAddOns: unknown;
  ContentGroups: unknown;
  IsPerUser: boolean;
  QuarterlyRate: number;
  OneTimeRate: number;
  SubscriptionCount: number;
  Quantity: number;
  ActivityEventData: unknown;
  Uid: string;
  Created: string;
  Updated: string;
}

export interface SubscriptionAddOn {
  AddOn: AddOn;
  Quantity: unknown;
  selected: boolean;
  isUserSelectable: boolean;
  BillingRenewalTerm: number;
}

// SUBSCRIPTION REOPEN
export interface IOutsetaSubscriptionReopenEvent {
  _objectType: string;
  BillingRenewalTerm: number;
  Account: unknown;
  Plan: IOutsetaPlanCommonEvent;
  Quantity: number;
  StartDate: string;
  EndDate: unknown;
  ExpirationDate: unknown;
  RenewalDate: string;
  NewRequiredQuantity: unknown;
  IsPlanUpgradeRequired: boolean;
  PlanUpgradeRequiredMessage: unknown;
  SubscriptionAddOns: unknown[];
  DiscountCouponSubscriptions: unknown[];
  DiscountCode: unknown;
  LatestInvoice: unknown;
  Rate: number;
  ActivityEventData: unknown;
  Uid: string;
  Created: string;
  Updated: string;
}

//COMMONS
export interface IOutsetaPlanCommonEvent {
  _objectType: string;
  Name: string;
  Description: unknown;
  PlanFamily: unknown;
  AccountRegistrationMode: number;
  IsQuantityEditable: boolean;
  MinimumQuantity: number;
  MaximumPeople: unknown;
  MonthlyRate: number;
  AnnualRate: number;
  QuarterlyRate: number;
  OneTimeRate: number;
  SetupFee: number;
  IsTaxable: boolean;
  IsActive: boolean;
  IsPerUser: boolean;
  RequirePaymentInformation: boolean;
  TrialPeriodDays: number;
  TrialUntilDate: unknown;
  ExpiresAfterMonths: number;
  ExpirationDate: unknown;
  PostLoginPath: unknown;
  StripeTaxCodeId: unknown;
  UnitOfMeasure: string;
  PlanAddOns: unknown[];
  ContentGroups: unknown;
  NumberOfSubscriptions: number;
  ActivityEventData: unknown;
  Uid: string;
  Created: string;
  Updated: string;
}

export interface IOutsetaSignupRegistrationDataEvent {
  Account: Account;
  BillingRenewalTerm: number;
  Plan: Plan;
  Quantity: number;
  SubscriptionAddOns: unknown[];
}

export interface Account {
  BillingAddress: BillingAddress;
  RagioneSociale: string;
  PIVA_CF: string;
  TipologiaCliente: string;
  PersonAccount: PersonAccount[];
}

export interface BillingAddress {
  AddressLine1: string;
  City: string;
  State: string;
  PostalCode: string;
  Country: string;
  isSameAs: boolean;
  countryCode: string;
}

export interface PersonAccount {
  IsPrimary: boolean;
  Person: Person;
}

export interface Person {
  FirstName: string;
  LastName: string;
  Email: string;
}

export interface Plan {
  _objectType: string;
  Name: string;
  Description: unknown;
  PlanFamily: unknown;
  AccountRegistrationMode: number;
  IsQuantityEditable: boolean;
  MinimumQuantity: number;
  MaximumPeople: unknown;
  MonthlyRate: number;
  AnnualRate: number;
  QuarterlyRate: number;
  OneTimeRate: number;
  SetupFee: number;
  SkipSetupFeeOnPlanChange: boolean;
  IsTaxable: boolean;
  IsActive: boolean;
  IsPerUser: boolean;
  RequirePaymentInformation: boolean;
  TrialPeriodDays: number;
  TrialUntilDate: unknown;
  ExpiresAfterMonths: number;
  ExpirationDate: unknown;
  PostLoginPath: unknown;
  StripeTaxCodeId: unknown;
  UnitOfMeasure: string;
  PlanAddOns: unknown[];
  ContentGroups: unknown;
  NumberOfSubscriptions: number;
  ActivityEventData: unknown;
  Uid: string;
  Created: string;
  Updated: string;
}
